import load from 'little-loader';

const defaultSdkCDN = 'https://vgc.no/stats/linkpulse/linkpulse.js?2017-12-20-2';

export default ({ cdn = defaultSdkCDN, trackerId = 'linkPulse' } = {}) => ({
    track(params) {
        return new Promise((resolve, reject) => {
            load(cdn, (err) => {
                if (err) {
                    return reject(err);
                }

                return resolve({
                    response: 'LinkPulse tracking completed.',
                    params,
                    trackerId,
                });
            });

            return undefined;
        });
    },
});



/** WEBPACK FOOTER **
 ** ./src/tracking/linkPulse-tracker.js
 **/